import React, { Component } from 'react';
import qs from 'qs';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
// var jwtDecode = require('jwt-decode');
// import { div, Button } from 'react-bootstrap';
// import './App.css';

class LineLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            idToken: '',
            iDEmail: '',
            idCode: '',
            name: ''
        }
        // this.setState({ code: new URLSearchParams(window.location.search).get("code") })
        this.getData();
    }

    getUrl() {
        let url = 'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1653982031&redirect_uri=http://localhost:3000/login&state=12345abcde&scope=profile%20openid%20email&nonce=09876xyz';
        this.props.history.push(url);

    }

    getData() {
        this.state.code = new URLSearchParams(window.location.search).get("code")
        let data = {
            code: this.state.code,
            client_id: '1653982031',
            redirect_url: 'http://localhost:3000/login',
            grant_type: 'authorization_code',
            client_secret: '6ea208250e14f63073da4a6e22f1275e',
        }
        axios({

            method: 'POST',
            url: 'https://api.line.me/oauth2/v2.1/token',
            headers: {
                'Content-Type': 'Application/x-www-form-urlencoded;charset=UTF-8'
            },
            data: qs.stringify({
                code: this.state.code,
                client_id: '1653982031',
                redirect_url: 'https://sharework-admin.bitpeboot.com/login',
                grant_type: 'authorization_code',
                client_secret: '6ea208250e14f63073da4a6e22f1275e',
            })

            // method: 'post',
            // // url: 'http://192.168.1.110/sharework_back_v2/public/backend/upload-product',
            // url: 'https://api.line.me/oauth2/v2.1/token',
            // // data: JSON.stringify(data),
            // data: data,
            // config: {
            //     headers: { 'Content-Type': 'Application/x-www-form-urlencoded;charset=UTF-8' }
            // }
        }).then(res => {
            console.log("here")
            this.setState({ idToken: jwtDecode(res.data.id_token), accessToken: res.data.access_token })
        })
        this.getSocialData();
        // axios.post('https://api.line.me/oauth2/v2.1/token', data, { headers: { 'Content-Type': 'Application/x-www-form-urlencoded' } }).then(res => {
        //     this.setState({ idToken: jwtDecode(res.data.id_token), accessToken: res.data.access_token })
        // })
        // var token = (this.state.idToken);
    }

    getSocialData() {
        axios({
            method: 'POST',
            url: 'https://api.line.me/oauth2/v2.1/verify',
            data: {
                id_token: this.state.idToken,
                client_id: '1653982031',
            }

            // method: 'post',
            // // url: 'http://192.168.1.110/sharework_back_v2/public/backend/upload-product',
            // url: 'https://api.line.me/oauth2/v2.1/token',
            // // data: JSON.stringify(data),
            // data: data,
            // config: {
            //     headers: { 'Content-Type': 'Application/x-www-form-urlencoded;charset=UTF-8' }
            // }
        }).then(res => {
            this.setState({ idEmail: res.data.email, name: res.data.name })
        })
    }

    login() {

        this.getUrl();

        // var token = 'eyJ0eXAiO.../// jwt token';

        // var decoded = jwtDecode(token);

        // let data = {
        //     response_type: 'code',
        //     client_id: '1653982031',
        //     redirect_uri: 'https://sharework-admin.bitpeboot.com',
        //     state: '12345abcde',
        //     scope: 'profile%20openid%20email',
        // }

        // // axios.post('https://access.line.me/oauth2/v2.1/authorize/' + data).then(res=>{
        // //     this.setState({code:res.data.})
        // // })
        // axios.post('https://api.line.me/oauth2/v2.1/token?grant_type=authorization_code&code=8XtUylAhmaJFshZ0ZesP&redirect_uri=https://sharework-admin.bitpeboot.com&client_id=1653982031&client_secret=6ea208250e14f63073da4a6e22f1275e').then(res => {
        //     this.setState({ token: res.data.id_token })
        // })
        // POST https://api.line.me/oauth2/v2.1/token/Content-Type:application/x-www-form-urlencoded/grant_type=authorization_code/
        // -H 'Content-Type: application/x-www-form-urlencoded' \
        // -d 'grant_type=authorization_code' \
        // -d 'code=xxx' \
        // -d 'redirect_uri=xxx' \
        // -d 'client_id=xxx' \
        // -d 'client_secret=xxx'
        // https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1653982031&redirect_uri=https://sharework-admin.bitpeboot.com&state=12345abcde&scope=profile%20openid%20email&nonce=09876xyz
    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                <div>
                    <div>
                        <div
                            bsStyle="primary"
                            className="btn-margin"
                            onClick={this.login.bind(this)}
                            style={{ cursor: 'pointer' }}
                        >
                            <img alt="" src={require("../../assets/images/Logo-LINE.png")} height="50px" width='100%' />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { LineLogin };
